// extracted by mini-css-extract-plugin
export default {"container":"sidebars-open-banking-accounts-sidebar_container","footerContainer":"sidebars-open-banking-accounts-sidebar_footerContainer"};